import React from 'react';

const fileIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);

export function AccessRequestItem({ primaryLine, metaLine, status, statusClassName }) {
  const badgeClass = statusClassName || 'ud-badge ud-badge--neutral';

  return (
    <li
      className="
        user-dash-access-li group flex items-center gap-3 rounded-xl px-3 py-3
        transition-all duration-200 ease-in-out
        hover:bg-gray-50 dark:hover:bg-slate-700/40
      "
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-blue-600 transition-transform duration-200 group-hover:scale-105 dark:bg-blue-500/10 dark:text-blue-400">
        {fileIcon}
      </div>
      <div className="min-w-0 flex-1">
        <div className="truncate text-[13px] font-semibold text-gray-900 dark:text-slate-100">
          {primaryLine}
        </div>
        <div className="mt-0.5 truncate text-[11px] font-medium text-gray-500 dark:text-slate-400">
          {metaLine}
        </div>
      </div>
      <span className={badgeClass}>
        {status}
      </span>
    </li>
  );
}

export default AccessRequestItem;
